import { getDecodedToken } from "@/utils/security";
import { authApi } from "./api.service";
import type { AuthResponseDto } from "@/types/user.types";

export const getUserProfileData = async () => {
  const response = await authApi.get<AuthResponseDto["user"]>('/v0/users/profile');
  return response.data;
};

export const getUserSnapshotData = async () => {
  const response = await authApi.get<any>('/v0/users/snapshot');
  return response.data;
};